import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AuthWrapper from './components/AuthWrapper'

// Import pages
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Devices from './pages/Devices'
import LocationLists from './pages/LocationLists'
import DataProducts from './pages/DataProducts'
import Configuration from './pages/Configuration'
import Diagnostics from './pages/Diagnostics'
import MapVisualization from './pages/MapVisualization'
import PrintMapMaker from './pages/PrintMapMaker'
import ThemeManagement from './pages/admin/ThemeManagement'
import BaseMapsManagement from './pages/admin/BaseMapsManagement'
import BaseMapCreate from './pages/admin/BaseMapCreate'
import BaseMapEdit from './pages/admin/BaseMapEdit'
import BaseMapDetailsPage from './pages/admin/BaseMapDetailsPage'
import UserThemes from './pages/UserThemes'
import UserProfile from './pages/UserProfile'
import OrdersAndLicenses from './pages/OrdersAndLicenses'
import ProductionWorkQueue from './pages/ProductionWorkQueue'
import UserManagement from './pages/UserManagement'
import AuditLog from './pages/AuditLog'
import GettingStarted from './pages/GettingStarted'
import PreviewMap from './pages/PreviewMap'

// Import components
import { AuthenticatedLayout } from './components/AuthenticatedLayout'
import { TopNavBar } from './components/TopNavBar'
import { RoleProvider } from './contexts/RoleContext'
import { RoleGuard } from './components/RoleGuard'

const App: React.FC = () => {
  return (
    <AuthWrapper>
      {({ signOut, user }) => user && (
        <RoleProvider>
          <TopNavBar user={user} signOut={signOut} />
          <AuthenticatedLayout user={user} signOut={signOut}>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/getting-started" element={<GettingStarted />} />
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/orders" element={<OrdersAndLicenses />} />
              <Route 
                path="/production/work-queue" 
                element={
                  <RoleGuard requiredRole={["Admin", "Production"]}>
                    <ProductionWorkQueue />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/users" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <Users />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/users" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <UserManagement />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/audit-log" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <AuditLog />
                  </RoleGuard>
                } 
              />
              <Route path="/devices" element={<Devices />} />
              <Route path="/location-lists" element={<LocationLists />} />
              <Route path="/location-lists/preview/:userId/:dataProduct" element={<PreviewMap />} />
              <Route path="/print-map-maker" element={<PrintMapMaker />} />
              <Route path="/data-products" element={<DataProducts />} />
              <Route 
                path="/configuration" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <Configuration />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/diagnostics" 
                element={
                  <RoleGuard requiredRole={["Admin", "Production"]}>
                    <Diagnostics />
                  </RoleGuard>
                } 
              />
              <Route path="/map" element={<MapVisualization />} />
              <Route path="/themes" element={<UserThemes />} />
              <Route 
                path="/admin/themes" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <ThemeManagement />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/base-maps" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <BaseMapsManagement />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/base-maps/create" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <BaseMapCreate />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/base-maps/:id" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <BaseMapDetailsPage />
                  </RoleGuard>
                } 
              />
              <Route 
                path="/admin/base-maps/:id/edit" 
                element={
                  <RoleGuard requiredRole="Admin">
                    <BaseMapEdit />
                  </RoleGuard>
                } 
              />
            </Routes>
          </AuthenticatedLayout>
        </RoleProvider>
      )}
    </AuthWrapper>
  )
}

export default App